import { useMachine } from '@xstate/react'
import { ClearDevicesProps } from 'api/clear-devices'
import { IndexRecordProps } from 'api/index-record'
import { DeactivateTMATTProps } from 'api/deactivate-tmatt'
import { DeactivateProps } from 'api/deactivate-user'
import { EnrollTMATTProps } from 'api/enroll-tmatt'
import { ReactivateTMATTProps } from 'api/reactivate-tmatt'
import { ReactivateProps } from 'api/reactivate-user'
import { ReinstateProps } from 'api/reinstate-user'
import { ResendLMSSignatureRequestProps } from 'api/resend-lms-signature-request'
import { SendInstructionsProps } from 'api/send-instructions'
import { UpdateProgressProps } from 'api/updateProgress-user'
import {
  requestMachine,
  RequestMachineContext,
  RequestMachineEventData,
} from 'machines/requestMachine'
import { useUsersActions } from 'providers'
import { useMemo } from 'react'
import { State } from 'xstate'

type SynchronousAccountActions = {
  deactivate: (input: DeactivateProps) => void
  lock: (input: { userId: string }) => void
  unlock: (input: { userId: string }) => void
  sendInstructions: (input: SendInstructionsProps) => void
  clearDevices: (input: ClearDevicesProps) => void
  indexRecord: (input: IndexRecordProps) => void
  reinstate: (input: ReinstateProps) => void
  reactivate: (input: ReactivateProps) => void
  progress: (input: UpdateProgressProps) => void
  resendLMSSignatureRequest: (input: ResendLMSSignatureRequestProps) => void
  reactivateTMATT: (input: ReactivateTMATTProps) => void
  deactivateTMATT: (input: DeactivateTMATTProps) => void
  enrollTMATT: (input: EnrollTMATTProps) => void
}

export type UseAccountActionsResponseProps = [
  State<
    RequestMachineContext,
    RequestMachineEventData,
    any,
    { value: any; context: RequestMachineContext }
  >,
  SynchronousAccountActions
]
/**
 * @returns [actions, xStateState]
 */
export const useAccountActions = (): UseAccountActionsResponseProps => {
  const [state, send] = useMachine(requestMachine)

  const { account: accountActions } = useUsersActions()
  const actions = useMemo(() => {
    const actions = {} as SynchronousAccountActions
    Object.entries(accountActions).forEach(([key, action]) => {
      actions[key as keyof SynchronousAccountActions] = (input: any) => {
        const promise = action(input)
        send('SET_PROMISE', { data: promise })
      }
    })
    return actions
  }, [accountActions, send])

  return [state, actions]
}
